<template>
  <div class="sm-select-plan">
    <plan-select
      :showHidden="false" 
      @submit="onPlanSubmit"
    >
      <template slot="header">
        <h2 class="sm-txt-center">Select a plan</h2>
        <!-- <p class="sm-lead sm-txt-center">Cancel anytime</p> -->
      </template>
    </plan-select>
    <!-- <faq-block :faq="faq" /> -->
    <company-info />
    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
// import FAQ from '@/views/page-elements/FAQ';
import PlanSelect from '@/views/page-elements/PlanSelect';
import CompanyInfo from '@/views/page-elements/CompanyInfo';
import { mapActions, mapGetters } from 'vuex';
import Spinner from "@/components/Spinner";

export default {
  name: 'select-plan',
  components: {
    //'faq-block': FAQ,
    'company-info': CompanyInfo,
    'plan-select': PlanSelect,
    'sm-spinner': Spinner,
  },
  data() {
    return {
      // faq: [{
      //   title: 'What is SphereMail?',
      //   text: 'SphereMail is a cloud based platform that simplifies mail management at coworking spaces in addition to generating virtual phone numbers to users. It resolves intra/inter-company mail, to and from remote staff, without losing a physical mail items; i.e. it gives corporations the opportunity to cut their high real estate cost and mobilize their workforce. In addition SphereMail also provides virtual phone numbers and extensions for seamless automated phone line management.',
      //   open: false
      // },
      // {
      //   title: 'Why join SphereMail network?',
      //   text: 'Simple, when you\'re part of our network, customers seeking a mailing address in your area can automatically signup, receive a mailing address and purchase a virtual phone.',
      //   open: false
      // },
      // {
      //   title: 'Do I have to pay to list my venue on your website?',
      //   text: 'No, listing your venue/space is free.',
      //   open: false
      // },
      // {
      //   title: 'How much do you charge when I have subscribers?',
      //   text: 'There are no subscription fees or hidden fees. It’s simple: as soon as you have members signed up, SphereMail’s revenue share is only 10%. This includes the cost of Credit Card processing, unlimited admins, the ability to create unlimited coupons, Real-time view activity and revenue reports, and the ability to create up to 8 subscription plans. Our service includes full access to a platform, which provides a payment processor, the ability to manage customers, and 24/7 phone/email support.',
      //   open: false
      // },
      // {
      //   title: 'What payment method do you use?',
      //   text: 'Funds are directly deposited into your account.',
      //   open: false
      // },
      // {
      //   title: 'Can I cancel anytime?',
      //   text: 'You sure can. Absolutely, as a matter of fact you can even export all customers gained through SphereMail system.',
      //   open: false
      // },
      // {
      //   title: 'What about support?',
      //   text: 'We are always here to assist. Please email us anytime 24/7: support@spheremail.co',
      //   open: false
      // }],

      showSpinner: false
    }
  },
  created() {
    this.showSpinner = true;
    this.getUserData()
      .then((res) => {
        if (!res)
          this.$router.push('/login');

        window.scrollTo(0, 0);
        if (this.userAccount.activated_on && this.userAccount.activated_on.length)
          this.$router.push('/');

        this.showSpinner = false;
      })
  },
  computed: {
    ...mapGetters({
      userAccount: 'account/userAccount',
      isAdmin: 'isAdmin'
    })
  },
  methods: {
    ...mapActions({
      getUserData: 'account/userData',
      updateUser: 'account/updateUser',
      subscriptionToPlan: 'account/subscriptionToPlan',
      setPlanPeriod: 'setPlanPeriod'
    }),
    onPlanSubmit(data) {
      let toSend = {
        plan_id: data.plan.id,
        term: data.term
      };

      this.subscriptionToPlan(toSend)
        .then(() => {
          this.$router.push(`/billing-info${this.addQuery()}`);
        });
    },
    addQuery() {
      let queryStr = '';

      if (this.$route.query.pmb_id)
        queryStr += `?pmb_id=${this.$route.query.pmb_id}`

      return queryStr;
    }
  }
}
</script>

<style lang="scss">
  // @import '@/assets/scss/general/mixins.scss';
  // @import '@/assets/scss/framework/scss-variables.scss';
  // @import '@/assets/scss/page-elements/_plan-select.scss';

  .sm-select-plan {
    position: relative;
  }

  .fade-text-enter,
  .fade-text-leave-to {
    opacity: 0 !important;
    transform: translateY(30px);
  }

  .fade-text-enter-active,
  .fade-text-leave-active {
    transition: transform .2s, opacity .2s;
  }
</style>